import { inject, Pipe, PipeTransform } from '@angular/core';
import { RemoteConfigNumberKey } from '@marmon/shared/types/config';
import { ConfigService } from '../services';

@Pipe({ name: 'configNumber' })
export class ConfigNumberPipe implements PipeTransform {
	readonly config = inject(ConfigService);

	transform(key: RemoteConfigNumberKey) {
		return this.config.getNumber(key as RemoteConfigNumberKey);
	}
}
